import React, { useCallback } from 'react'
import { Route, Switch } from 'react-router'
import { useHistory } from 'react-router-dom'
import { Tabs } from 'antd'
import { Panel } from '../../../core/components/styled'
import { useLastPathnameSegment } from '../../../common/hooks/router'
import ScrapingSessionsManagementPage from './scraping-sessions-management-page'
import ScrapingSessionsHistoryPage from './scraping-sessions-history-page'

const ScrapingTagsPage = () => {
  const history = useHistory()
  const currentTab = useLastPathnameSegment()

  const handleChangeTab = useCallback(
    tabKey => history.push(`/scraping/sessions/${tabKey}`),
    [history],
  )

  return (
    <>
      <Panel margin="small no no no">
        <Tabs type="card" activeKey={currentTab} onChange={handleChangeTab}>
          <Tabs.TabPane tab="Sessions management" key="management" />
          <Tabs.TabPane tab="Sessions history" key="history" />
        </Tabs>
      </Panel>

      <Switch>
        <Route
          path="/scraping/sessions/management"
          component={ScrapingSessionsManagementPage}
        />
        <Route
          path="/scraping/sessions/history"
          component={ScrapingSessionsHistoryPage}
        />
      </Switch>
    </>
  )
}
export default ScrapingTagsPage
